import { render, staticRenderFns } from "./AssignTaskModal.vue?vue&type=template&id=33148f6c"
import script from "./AssignTaskModal.vue?vue&type=script&lang=js"
export * from "./AssignTaskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports